import { Controller } from 'stimulus';
import Rails from "@rails/ujs";

export default class extends Controller {
  static targets = ['checkbox', 'clickedCheckbox'];

  toggle(event) {
    this.checkboxTargets.forEach((checkbox) => {
      checkbox.checked = event.target.checked;
      checkbox.dispatchEvent(new Event('change'));
    });
  }

  callMethod() {
    let _this = this.clickedCheckboxTarget;

    Rails.ajax({
      dataType: 'json',
      type: _this.dataset.method,
      url: _this.dataset.url,
      data: _this.dataset.body || '',
      error: () => {
        alert('Произошла ошибка при вызове метода!');
      }
    });
  }
}
